// Variante de vocabulaire active (« lab » pour un parc de catégorie Laboratoire,
// issue #1096). Module sans dépendance : le moteur PDF et le Centre d'aide la
// lisent sans charger i18n (dont l'import réveille react-i18next dans les tests
// et les chunks qui n'en ont pas besoin). src/i18n.js la tient à jour.
let currentVariant = null;

export const getWelfareVariant = () => currentVariant;
export const setWelfareVariantState = (variant) => {
  currentVariant = variant || null;
};
